import { Observable } from 'rxjs';

export abstract class ApPersonalizationService {
    abstract loadPlatform(): Observable<boolean>;
}
